module.exports = __webpack_public_path__ + "img/Over Deep Engraving.4c953ac3.png";